import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'gen-range-input',
  templateUrl: './range-input.component.html',
  styleUrls: ['range-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class RangeInputComponent implements OnInit {

  @Input() filter: any;
  constructor() {

  }

  ngOnInit() {
    this.checkRange(this.filter);
  }

  checkRange(filter) {
    if (filter.selectedValue.from && filter.selectedValue.to) {
      filter.tooltip = filter.selectedValue.from + '-' + filter.selectedValue.to;
    }
    else if (filter.selectedValue.from) {
      filter.tooltip = filter.selectedValue.from;
 }
    else {
      filter.selectedValue.to;
 }
  }


}
